import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

/**
 * SortableTh — sortable table header cell (replaces per-page SortHeader copies).
 * `align="right"` applies the `num` class for right-aligned numeric columns.
 */
export default function SortableTh({
  label,
  sortKey,
  activeKey,
  dir,
  onSort,
  align = 'left',
  className = '',
}) {
  const active = activeKey === sortKey;
  const Icon = active ? (dir === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown;
  const classes = [align === 'right' ? 'num' : '', className].filter(Boolean).join(' ');

  return (
    <th
      className={classes || undefined}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        className={`table-sortable${active ? ' table-sortable--active' : ''}`}
        onClick={() => onSort(sortKey)}
      >
        {label}
        <Icon size={13} />
      </button>
    </th>
  );
}
